import '../../styles/map-coord.css'

export default function MouseCoord (L, projection, proj4, map, projectionName = 'Unknown') {
    const createProjection = (projText) => {
        if (!projText) return null
        try {
            return proj4(projText)
        } catch (e) {
            console.error('Failed to initialize projection:', e)
            return null
        }
    }

    let prj = createProjection(projection)
    let _container = null
    let _currentProjectionName = projectionName
    let _isProjectProjection = false

    const onMouseMove = (e) => {
        const projectTag = _isProjectProjection ? ' <span style="color: #888;">[Project]</span>' : ''
        
        if (!prj) {
            _container.innerHTML = `${e.latlng.lng?.toFixed(6)} | ${e.latlng.lat?.toFixed(6)} <span style="color: #888; margin-left: 8px;">[WGS84]</span>`;
            return
        }

        const projCoords = prj.forward([e.latlng.lng, e.latlng.lat])
        _container.innerHTML = `${projCoords[0]?.toFixed(2)} | ${projCoords[1]?.toFixed(2)} <span style="color: #888; margin-left: 8px;">[${_currentProjectionName}]</span>${projectTag}`;
    }

    const bottomLeft = L.control({
        position: 'bottomleft'
    });

    bottomLeft.onAdd = function (map) {
        _container = L.DomUtil.create('div', 'leaflet-control-coord-projection');
        L.DomEvent.disableClickPropagation(_container);
        map.on('mousemove', onMouseMove, this);
        _container.innerHTML=this.options.emptyString;
        return _container;
    };

    bottomLeft.onRemove = function (map) {
        map.off('mousemove', onMouseMove)
    }

    bottomLeft.addTo(map);

    // Return update function for projection changes
    return {
        updateProjection: (newProjection, newProjectionName, isProjectProjection = false) => {
            prj = createProjection(newProjection)
            _currentProjectionName = newProjectionName || 'Unknown'
            _isProjectProjection = isProjectProjection
        }
    }

    // L.Map.mergeOptions({
    //     positionControl: false
    // });
    //
    // L.Map.addInitHook(function () {
    //     if (this.options.positionControl) {
    //         this.positionControl = new L.Control.coordProjection();
    //         this.addControl(this.positionControl);
    //     }
    // });
    //
    // L.control.coordProjection = function (options) {
    //     return new L.Control.coordProjection(options);
    // };
}